import { render, staticRenderFns } from "./ModalUpdateCommentService.vue?vue&type=template&id=23e35e0d"
import script from "./ModalUpdateCommentService.vue?vue&type=script&lang=js"
export * from "./ModalUpdateCommentService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports